<template>
  <div class="box">
    <el-drawer
      :visible.sync="visible"
      :wrapperClosable="false"
      :show-close="false"
      :close-on-press-escape="false"
      custom-class="drawer1"
      :title="title"
      :size="size"
    >

    <div slot="title" style="border-bottom:1px solid #ccc;padding-bottom:10px;">
        “
        <span style="color:red">{{detailInfo.unit_name}}</span>
        ” 的立项信息
      </div>
      <div style="padding:20px;margin-bottom:80px">
        <el-tabs v-model="activeName" type="card">
          <el-tab-pane label="基本信息" name="1">
            <el-row type="flex" justify="center" style="padding:10px">
              <el-col
                :span="10"
              >项目名称：{{detailInfo.project_before_type == 2?detailInfo.full_project_name:detailInfo.project_name}}</el-col>
              <el-col :span="10">项目类型：{{detailInfo.project_before_type_text}}</el-col>
            </el-row>

            <el-row type="flex" justify="center" style="padding:10px">
              <el-col :span="10">公益事务代表：{{detailInfo.resident_agent}}</el-col>
              <el-col :span="10">
                项目对接人：
                {{detailInfo.group_leader}}
              </el-col>
            </el-row>

            <el-row type="flex" justify="center" style="padding:10px">
              <el-col :span="10">项目开始时间：{{detailInfo.regdate_start}}</el-col>
              <el-col :span="10">项目结束时间：{{detailInfo.regdate_end}}</el-col>
            </el-row>

            <el-row type="flex" justify="center" style="padding:10px" v-if="detailInfo.duties">
              <el-col :span="10">负责人职务：{{detailInfo.duties}}</el-col>
              <el-col :span="10">负责人联系方式：{{detailInfo.contact}}</el-col>
            </el-row>

            <el-row type="flex" justify="center" style="padding:10px">
              <el-col :span="10">医保局备案：{{detailInfo.if_medival_report == 1?'是':'否'}}</el-col>
              <el-col :span="10">卫计委备案：{{detailInfo.if_hygiene_report == 1?'是':'否'}}</el-col>
            </el-row>

            <el-row type="flex" justify="center" style="padding:10px">
              <el-col
                :span="10"
              >{{detailInfo.if_medival_report == 1?'医保局备案信息：':'医保局备案计划：'}}{{detailInfo.if_medival_report == 1?detailInfo.medival_report_info:detailInfo.medival_report_plan}}</el-col>
              <el-col
                :span="10"
              >{{detailInfo.if_hygiene_report == 1?'卫计委备案信息：':'卫计委备案计划：'}}{{detailInfo.if_hygiene_report == 1?detailInfo.hygiene_report_info:detailInfo.hygiene_report_plan}}</el-col>
            </el-row>

            <!-- <el-row type="flex" justify="center" style="padding:10px">
              <el-col :span="10">合作机构：{{detailInfo.cat_id_text}}</el-col>
              <el-col
                :span="10"
              >合作机构区域：{{detailInfo.cat_province + '/' + detailInfo.cat_city + '/' + detailInfo.cat_county}}</el-col>
            </el-row>-->

            <el-row type="flex" justify="center" style="padding:10px">
              <el-col :span="10">项目周期：{{detailInfo.project_cycle}} 个月</el-col>
              <el-col :span="10">项目总预算：{{detailInfo.total_funds | setNumFormat}} 元</el-col>
            </el-row>
            <el-row type="flex" justify="center" style="padding:10px">
              <el-col :span="20">
                覆盖地域：
                {{address.join("、")}}
              </el-col>
            </el-row>
            <el-row type="flex" justify="center" style="padding:10px">
              <el-col :span="20">
                救助对象：
                {{detailInfo.fund_use}}
              </el-col>
            </el-row>

            <el-row type="flex" justify="center" style="padding:10px">
              <el-col :span="20">
                合同协议盖章：
                <div
                  v-if="detailInfo.agree_stamp && detailInfo.agree_stamp[0]"
                  style="margin-top:10px"
                >
                  <a
                    v-for="item in detailInfo.agree_stamp"
                    :key="item.id"
                    style="text-decoration: underline; color: #333; cursor: pointer;color:#4682B4;margin-right:10px"
                    target="_blank"
                    :href="item.url"
                  >{{ item.name }}</a>
                  <p style="clear: both; padding-top: 10px">
                    <i class="el-icon-info" size="18" style="clear: both;"></i>
                    &nbsp;点击文件名进行预览
                  </p>
                </div>
                <span v-else style="color:red">暂未进行协议盖章~</span>
              </el-col>
            </el-row>

            <el-row type="flex" justify="center" style="padding:10px">
              <el-col :span="20">
                <p style="padding-bottom:15px">项目预算：</p>
                <el-table :data="detailInfo.funds" border>
                  <el-table-column prop="cost_item_text" label="眼疾" align="center">
                    <template
                      slot-scope="scope"
                    >{{scope.row.cost_item_text+"（"+scope.row.unit_text+"）"}}</template>
                  </el-table-column>

                  <el-table-column prop="budget_amount" label="金额区间" align="center">
                    <template
                      slot-scope="scope"
                    >{{scope.row.funds_start | setNumFormat}} - {{scope.row.funds_end | setNumFormat}} 元</template>
                  </el-table-column>
                  <el-table-column prop="total_number" label="预计人数" align="center">
                    <template slot-scope="scope">{{scope.row.total_number | setNumFormat(false)}} 人</template>
                  </el-table-column>
                </el-table>
              </el-col>
            </el-row>
          </el-tab-pane>
          <el-tab-pane label="项目执行计划" name="2">
            <el-row type="flex" justify="center" style="padding:10px">
              <el-col :span="20">
                <p style="padding-bottom:15px">结算计划：</p>
                <el-table :data="detailInfo.payment_plan" border>
                  <el-table-column prop="plan_time" label="捐款时间" align="center"></el-table-column>
                  <el-table-column prop="plan_money" label="捐款金额" align="center">
                    <template slot-scope="scope">{{scope.row.plan_money | setNumFormat}} 元</template>
                  </el-table-column>
                </el-table>
              </el-col>
              <!-- <el-col :span="20" v-if="detailInfo.project_funds_type == 2">
                回捐协议附件：
                <span
                  @click="downFile(detailInfo.return_agreement_id, detailInfo.return_agreement_id_path[0].name)"
                  style="text-decoration: underline; color: #333; cursor: pointer;color:#4682B4 "
                >{{ detailInfo.return_agreement_id_path[0].name }}</span>
                <p style="clear: both; padding-top: 10px">
                  <i class="el-icon-info" size="18" style="clear: both;"></i>
                  &nbsp;点击文件名进行下载查看
                </p>
              </el-col>-->
            </el-row>

            <el-row
              type="flex"
              justify="center"
              style="padding:10px"
              v-if="detailInfo.project_before_type == 1"
            >
              <el-col :span="20">
                月度项目执行计划表：
                <el-table :data="detailInfo.plan_content" border>
                  <el-table-column prop="month" label="日期" align="center"></el-table-column>
                  <el-table-column prop="number" label="筛查人数" align="center"></el-table-column>
                  <el-table-column prop="case" label="救助例数" align="center"></el-table-column>
                </el-table>
              </el-col>
            </el-row>
          </el-tab-pane>
          <el-tab-pane label="合作方信息" name="3">
            <el-row type="flex" justify="center" style="padding:10px">
              <el-col :span="10">合作方名称：{{detailInfo.finance.collaborator_name}}</el-col>
              <el-col :span="10">法人：{{detailInfo.finance.corporation}}</el-col>
            </el-row>
            <el-row type="flex" justify="center" style="padding:10px">
              <el-col :span="10">联系人：{{detailInfo.finance.contacts}}</el-col>
              <el-col :span="10">收款单位名称：{{detailInfo.finance.payee_unit_name}}</el-col>
            </el-row>
            <el-row type="flex" justify="center" style="padding:10px">
              <el-col :span="10">收款单位联系人：{{detailInfo.finance.payee_rela_user_name}}</el-col>
              <el-col :span="10">收款单位联系手机：{{detailInfo.finance.payee_office_phone}}</el-col>
            </el-row>
            <el-row type="flex" justify="center" style="padding:10px">
              <el-col :span="10">收款单位开户行：{{detailInfo.finance.bank_name}}</el-col>
              <el-col :span="10">收款单位开户名：{{detailInfo.finance.account_name}}</el-col>
            </el-row>
            <el-row type="flex" justify="center" style="padding:10px">
              <el-col :span="20">收款单位账号：{{detailInfo.finance.account_number}}</el-col>
            </el-row>
            <el-row type="flex" justify="center" style="padding:10px">
              <el-col :span="20">业务范围：{{detailInfo.finance.business_scope}}</el-col>
            </el-row>
          </el-tab-pane>

          <el-tab-pane label="扩展信息" name="4">
            <el-row
              type="flex"
              justify="center"
              style="padding:10px"
              v-if="detailInfo.project_before_type == 1"
            >
              <el-col :span="20">
                项目执行团队信息：
                <el-table :data="detailInfo.project_team" border>
                  <el-table-column prop="user_name" label="姓名" align="center"></el-table-column>
                  <el-table-column prop="duties" label="职位" align="center"></el-table-column>
                  <el-table-column prop="type_text" label="分工" align="center"></el-table-column>
                </el-table>
              </el-col>
            </el-row>
            <el-row
              type="flex"
              justify="center"
              style="padding:10px"
              v-for="(item,index) in detailInfo.approval_files"
              :key="index"
            >
              <el-col :span="20" v-if="item.file_type == 1">
                {{item.file_type_name}}：
                <div v-if="item.file_path[0]" style="padding:10px 0">
                  <!-- <span
                    @click="downFile(val.id, val.name)"
                    :key="'file'+key"
                    v-for="(val,key) in item.file_path"
                    style="text-decoration: underline; color: #333; cursor: pointer;color:#4682B4;margin-right:10px"
                  >{{ val.name }}</span>-->
                  <a
                    style="margin:10px"
                    :href="val.url"
                    target="_blank"
                    :key="'file'+key"
                    v-for="(val,key) in item.file_path"
                  >{{val.name}}</a>

                  <p style="clear: both; padding-top: 10px">
                    <i class="el-icon-info" size="18" style="clear: both;"></i>
                    &nbsp;点击文件名进行下载
                  </p>
                </div>
                <span v-else>暂无附件~</span>
              </el-col>

              <el-col :span="20" v-if="item.file_type == 2">
                {{item.file_type_name}}：
                <div v-if="item.file_path[0]">
                  <img
                    :src="val.url"
                    alt
                    :key="'img'+key"
                    v-for="(val,key) in item.file_path"
                    @click="showImg(val.url)"
                    style="width:50px;height:50px;margin:10px"
                  />
                  <p style="clear: both; padding-top: 10px">
                    <i class="el-icon-info" size="18" style="clear: both;"></i>
                    &nbsp;点击图片进行查看
                  </p>
                </div>
                <span v-else>暂无图片~</span>
              </el-col>
            </el-row>
            <el-dialog :visible.sync="img_show" :append-to-body="true">
              <img width="100%" :src="img_url" alt />
            </el-dialog>
          </el-tab-pane>
        </el-tabs>
      </div>

      <div class="demo-drawer-footer">
        <el-button type="danger" size="small" icon="el-icon-close" @click="close">关闭</el-button>
      </div>
    </el-drawer>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: "立项信息"
    },
    size: {
      type: [String, Number],
      default: "75%"
    },
    id: {
      type: [String, Number],
      default: null
    }
  },

  data() {
    return {
      visible: false,
      loading: false,
      img_show: false,
      img_url: null,
      detailInfo: { finance: {} },
      activeName: "1",
      address: []
    };
  },

  methods: {
    close() {
      this.visible = false;
    },

    //查看大图
    showImg(url) {
      this.img_url = url;
      this.img_show = true;
    },

    //获取详情数据
    getDetailInfo() {
      this.$db
        .post(this.$db.config.com_project.approval.detail, { id: this.id })
        .then(res => {
          if (res && res.code == 200) {
            this.detailInfo = res.data;
            let arr = [];
            if (res.data.address[0]) {
              res.data.address.forEach(item => {
                let info;
                if (item.province_id > 0) {
                  info = item.province;
                  if (item.city_id > 0) {
                    info += "/" + item.city;
                  }
                  if (item.county_id > 0) {
                    info += "/" + item.county;
                  }
                }
                arr.push(info);
              });
              this.address = arr;
            } else {
              this.address[0] = "不限制覆盖地域";
            }
          }
        });
    },

    downFile(id, name) {
      this.$db
        .downFilePost(this.$db.config.downloadFileUrl, { file_id: id })
        .then(res => {
          if (res.hasOwnProperty("code")) {
            var enc = new TextDecoder("utf-8");
            var result = JSON.parse(enc.decode(new Uint8Array(res)));
          } else {
            this.download(res, name);
          }
        });
    },
    // 下载文件
    download(data, name) {
      if (!data) {
        return;
      }
      let blob = new Blob([data], { type: "application/octet-stream" });
      let url = window.URL.createObjectURL(blob);
      let alink = document.createElement("a");
      alink.href = url;

      alink.download = name; //文件名
      alink.click();
      this.downConfirm = false;
    }
  },
  watch: {
    visible(val) {
      this.$emit("input", val);
    },

    value: {
      handler(val) {
        this.visible = val;
      },
      immediate: true
    }
  },
  created() {
    if (this.id > 0) {
      this.getDetailInfo();
    }
  }
};
</script>
<style lang="scss" scoped>
.box /deep/ .drawer1 {
  overflow: auto;
}
.demo-drawer-footer {
  width: 75%;
  position: fixed;
  bottom: 0;
  right: 0;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: right;
  background: #fff;
}
</style>


// WEBPACK FOOTER //
// src/components/Hospital/comproject/approval/detail.vue